import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m18.228 5.742.512.85c.313.519.738 1.225 1.188 1.976a305 305 0 0 1 2.319 3.908 2.4 2.4 0 0 1 .252 1.047c-.112 2.465-2.126 4.466-4.678 4.576h-.044c-2.454-.111-4.454-2.01-4.676-4.556L13.1 13.5v-.018c0-.137 0-.306.034-.48.039-.193.115-.375.242-.568l3.994-6.69a.5.5 0 0 1 .858-.002m-.426 1.23-3.573 5.984-.013.021a.6.6 0 0 0-.101.221 1.5 1.5 0 0 0-.015.28c.187 2.035 1.77 3.523 3.7 3.621 2.033-.099 3.606-1.687 3.7-3.61a1.4 1.4 0 0 0-.142-.554c-.402-.702-1.392-2.36-2.287-3.853l-1.187-1.974z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.95 13.1a.75.75 0 0 1 .75-.75H22a.75.75 0 0 1 0 1.5h-8.3a.75.75 0 0 1-.75-.75M6.1 8.9a.5.5 0 0 1 .43.244l4 6.7.018.033a2.4 2.4 0 0 1 .252 1.046c-.112 2.465-2.126 4.466-4.678 4.577h-.044c-2.454-.112-4.454-2.01-4.676-4.556L1.4 16.9c0-.333.1-.607.179-.824l.047-.134a.5.5 0 0 1 .045-.098l4-6.7a.5.5 0 0 1 .43-.244m0 1.476L2.557 16.31q-.035.102-.062.177c-.062.176-.092.26-.094.392.187 2.034 1.771 3.521 3.7 3.62 2.033-.1 3.606-1.688 3.7-3.61a1.4 1.4 0 0 0-.14-.55z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.25 16.5a.75.75 0 0 1 .75-.75h8.3a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M18.52 5.79a.75.75 0 0 1-.51.93l-11.6 3.4a.75.75 0 0 1-.422-1.44l11.6-3.4a.75.75 0 0 1 .931.51",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.2 3.25a.75.75 0 0 1 .75.75v3.9a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }